import styled from "styled-components";
import { colorToken } from "components/utils/constants";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  width:100vw;
  height:100vh;
  background-color: rgba(9, 50, 97, 0.8);
  display: flex;
  justify-content: center;
  z-index: 1000;
  overflow-y: auto;
  padding: 90px 0;
`;

export const ModalContainer = styled.div`
  background-color: white;
  padding: 24px;
  border-radius: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 560px;
  width: 90%;
  position: relative;
  height: fit-content;
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  color: #666;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #333;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  }
`;
